// extracted by mini-css-extract-plugin
module.exports = {"images":"picturelist_images__1gQon","img":"picturelist_img__32QHV","helpfull":"picturelist_helpfull__11BN2"};